/* globals
    $:true,
    jQuery:true,
    Backbone:true,
    Mustache:true,
    Rover:true,
    _:true,
    moment:true
    Url:true
*/

export default Backbone.Model.extend({
  initialize(options) {
    const self = this;

    _.bindAll(
      self,
      '_fetchAPIKey',
      '_fetchPerformanceMetrics',
      '_formatPerformanceMetrics',
      '_formatConditionalContent',
      'fetchPerformanceMetrics'
    );

    self.data = {
      activeServiceType: null,
      activePerformanceMetric: null,
      serviceTypes: [],
      services: {},
    };
  },

  // Fetch Base API_Key
  _fetchAPIKey() {
    const self = this;
    const apiKeyEndpoint = `${Rover.urls.base}api/v3/api_key/`;
    return $.getJSON(apiKeyEndpoint);
  },

  // Fetch Users Performance Metrics from API Endpoint
  _fetchPerformanceMetrics(apiKey) {
    const self = this;
    const performanceMetricsEndpoint = `${Rover.urls.base}api/v3/people/${
      apiKey.person_opk
    }/performance/`;
    return $.getJSON(performanceMetricsEndpoint);
  },

  // Properly format returned performance metrics json to easier templating data
  _formatPerformanceMetrics(model) {
    const self = this;
    self.model = model;

    // Loop through results and push into
    _.each(self.model.results, (obj, i) => {
      self.data.serviceTypes.push(obj.service_type);
      self.data.services[obj.service_type.slug] = obj;
    });
  },

  // Properly format conditional text content for mustache template
  _formatConditionalContent() {
    const self = this;

    // Loop through each service and create the objects conditional statement for mustache template
    _.each(self.data.services, (obj, i) => {
      const service = self.data.services[obj.service_type.slug];
      const bookingScoreConditional = `${obj.booking_score.confidence_level}_${
        obj.booking_score.performance_level
      }`;
      const repeatScoreConditional = `${obj.repeat_score.confidence_level}_${
        obj.repeat_score.performance_level
      }`;

      const bookingScoreConfidenceLevel = service.booking_score.confidence_level;
      const repeatScoreConfidenceLevel = service.repeat_score.confidence_level;

      service.booking_score[`confidence_level_${bookingScoreConfidenceLevel}`] = true;
      service.repeat_score[`confidence_level_${repeatScoreConfidenceLevel}`] = true;

      // Check confidence_level on booking_score and repeat_score
      if (bookingScoreConfidenceLevel === 'none') {
        service.bookingScoreBlocked = true;
      } else {
        service.booking_score.conditionalType = {};
        service.booking_rate.conditionalType = {};
        service.booking_score.conditionalType[bookingScoreConditional] = true;
        service.booking_rate.conditionalType[bookingScoreConditional] = true;
      }
      if (repeatScoreConfidenceLevel === 'none') {
        service.repeatScoreBlocked = true;
      } else {
        service.repeat_score.conditionalType = {};
        service.repeat_score.conditionalType[repeatScoreConditional] = true;
        service.repeat_bookings_count.conditionalType = {};
        service.repeat_bookings_count.conditionalType[repeatScoreConditional] = true;
      }
    });
  },

  // Public API
  //
  // ** fetchPerformanceMetrics() **
  // returns a thenable object which passes along the formatted performance metrics
  // returns error if fetch occurs at any point.
  fetchPerformanceMetrics() {
    const self = this;
    const deferred = $.Deferred();

    // Prefetch Performance Data
    self
      ._fetchAPIKey()
      .then(self._fetchPerformanceMetrics)
      .then(self._formatPerformanceMetrics)
      .then(self._formatConditionalContent)
      .then(() => {
        if (!self.model.count) {
          deferred.reject(null);
        } else {
          deferred.resolve(self.data);
        }
      })
      .fail(() => {
        deferred.reject();
      });

    return deferred;
  },
});



// WEBPACK FOOTER //
// ./js/services/performance_metrics.js